import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './QuestionIndex.scss';

/**
 * Renders question info
 * */
class QuestionIndex extends PureComponent {
  static displayName = 'QuestionIndex';

  static propTypes = {
    index: PropTypes.number.isRequired,
  };

  render() {
    const { index } = this.props;

    return (
      <span className="question-nr">
        <h1>Question {index}</h1>
      </span>
    );
  }
}

export default QuestionIndex;
